(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/group-header/assets/javascripts/group-header.js') >= 0) return;  svs.modules.push('/components/marketplace/group-header/assets/javascripts/group-header.js');

'use strict';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const _ReactRouterDOM = ReactRouterDOM,
  useRouteMatch = _ReactRouterDOM.useRouteMatch;
const ReactIcon = svs.ui.ReactIcon;
const roles = svs.components.marketplaceData.auth.roles;
const useChatHandler = svs.components.marketplace.chat.useChatHandler;
const GroupHeader = _ref => {
  let className = _ref.className,
    color = _ref.color,
    displayMenu = _ref.displayMenu,
    hasChatButton = _ref.hasChatButton,
    isCaptain = _ref.isCaptain,
    isInverted = _ref.isInverted,
    isUnreadCountVisible = _ref.isUnreadCountVisible,
    myRole = _ref.myRole,
    onClickEndTeam = _ref.onClickEndTeam,
    onClickLeaveTeam = _ref.onClickLeaveTeam,
    onGoBack = _ref.onGoBack,
    teamName = _ref.teamName,
    unreadMessages = _ref.unreadMessages;
  const _useRouteMatch = useRouteMatch(),
    params = _useRouteMatch.params;
  const groupId = Number(params.groupId);
  const _useChatHandler = useChatHandler(groupId),
    aria = _useChatHandler.aria,
    handleChat = _useChatHandler.handleChat,
    label = _useChatHandler.label;
  const buttonPermissions = {
    canEndTeam: displayMenu && myRole && roles.hasPermission(myRole, roles.PERMISSIONS.END_TEAM),
    canLeave: displayMenu && myRole && roles.hasPermission(myRole, roles.PERMISSIONS.LEAVE_TEAM)
  };
  const canEndTeam = buttonPermissions.canEndTeam,
    canLeave = buttonPermissions.canLeave;
  const RightButton = () => React.createElement("div", {
    className: "btn-group group-header-right-buttons"
  }, isCaptain && React.createElement("div", {
    "aria-disabled": "true"
  }, React.createElement(ReactIcon, {
    className: "margin-right margin-left",
    color: "fc-black",
    icon: "team-captain",
    size: "300"
  })), canLeave && React.createElement("div", null, React.createElement("button", {
    className: "btn btn-100 btn-transparent-default no-wrap margin-0 popover-action-btn qa-action-btn f-left",
    onClick: onClickLeaveTeam,
    type: "button"
  }, "L\xE4mna lag")), canEndTeam && React.createElement("div", null, React.createElement("button", {
    className: "btn btn-100 btn-transparent-default no-wrap margin-0 popover-action-btn qa-action-btn f-left",
    onClick: onClickEndTeam,
    type: "button"
  }, "Avsluta lag")));
  const renderUnreadMessagesIcon = () => React.createElement("div", {
    className: "team-unread-messages-container"
  }, React.createElement(ReactIcon, {
    color: "fc-navy",
    icon: "chat",
    size: "300"
  }), React.createElement("div", {
    "aria-label": "You have unread messages",
    "aria-live": "polite",
    className: "team-unread-message-circle",
    role: "status"
  }));
  const rootClassNames = ['team-header'];
  if (isInverted) {
    rootClassNames.push('inverted');
  }
  if (className) {
    rootClassNames.push(className);
  }
  const style = {};
  if (color) {
    style['--color'] = color;
  }
  return React.createElement("div", {
    className: "team-header-holder"
  }, React.createElement("div", {
    className: rootClassNames.join(' '),
    style: style
  }, React.createElement("div", {
    className: "team-header-first-row"
  }, React.createElement("div", {
    className: "back-container"
  }, onGoBack ? React.createElement("button", {
    "aria-label": "Tillbaka",
    className: "qa-back-button icon-button",
    onClick: onGoBack,
    type: "button"
  }, React.createElement(ReactIcon, {
    icon: "arrow-left",
    size: "300"
  })) : React.createElement("div", null)), isUnreadCountVisible && unreadMessages > 0 && React.createElement("div", {
    className: "team-unread-messages"
  }, renderUnreadMessagesIcon())), React.createElement("h2", {
    "aria-label": isCaptain ? "".concat(teamName, ", du \xE4r lagkapten") : teamName,
    className: "margin-0 team-title f-bold f-700"
  }, teamName), hasChatButton && React.createElement("button", _extends({}, aria, {
    className: "qa-chat sr-only",
    onClick: handleChat,
    type: "button"
  }), label), React.createElement(RightButton, null)));
};
GroupHeader.defaultProps = {
  className: '',
  displayMenu: false,
  hasChatButton: false,
  history: {
    push: () => null
  },
  isInverted: false,
  isUnreadCountVisible: true
};
setGlobal('svs.components.marketplace.groupHeader.GroupHeader', GroupHeader);

 })(window);